<template>
    <div class="page">
        <div class="downloadCon" ref="import" >
            <div>篇幅有限,下載<span class="name">「嗨文小說」</span>APP</div>
<!--            <div>搜索數字 <span id="num" ref="num" class="num" :data-clipboard-text="`haiwen_${copyCon}`" @click="copy()"> {{copyCon}} </span>繼續閱讀...</div>-->
            <div>免費閱讀更多精彩內容...</div>
        </div>
        <div class="clickImage">
            <img src="../../assets/extension/tip.gif"/>
        </div>
        <div class="center">
            <a class="download-btn" :data-clipboard-text="`haiwen_${copyCon}`" @click="downApp()" href="javascript:void(0);"><img src="../../assets/extension/btn.png"/></a>
        </div>
    </div>
</template>

<script>
    import "utils/core/rem";
    import Clipboard from 'clipboard'
    /*Facebook Pixel Code*/
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '604117387548801');
    fbq('track', 'PageView');
    import { extensionDetail } from "apiurl/extension";
    export default {
        name: "",
        data () {
            return {
                copyCon: '24',
                bookName: '马甲',
            }
        },
        mounted () {
            if (this.$route.query.num) {
                this.copyCon = this.$route.query.num
                this.bookName = this.$route.query.name
            }
            this.getDetail(this.bookName, 'load')
        },
        methods: {
            async getDetail (name, action) {
                let res = await extensionDetail(name, action);
            },
            copy () {
                var clipboard = new Clipboard('.download-btn')
                clipboard.on('success', e => {
                    console.log('复制成功')
                    //  释放内存
                    clipboard.destroy()
                })
                clipboard.on('error', e =>{
                    // 不支持复制
                    console.log('该浏览器不支持复制')
                    // 释放内存
                    clipboard.destroy()
                })
            },
            downApp() {
                this.copy()
                fbq('track', 'Purchase', {currency: "USD", value: 0.01});
                let ua = navigator.userAgent.toLowerCase();
                //Android终端
                let isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;
          　     //Ios终端
                let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
                    window.location.href = 'https://apps.apple.com/cn/app/%E5%97%A8%E6%96%87%E5%B0%8F%E8%AA%AA/id1485535288'
                    this.getDetail(this.bookName, 'click')
                } else if (/(Android)/i.test(navigator.userAgent)) {
                    //Android终端
                    this.getDetail(this.bookName, 'click')
                    window.location.href = 'https://play.google.com/store/apps/details?id=com.haiwen.reader'
                }
            },
        },
    }
</script>
<noscript><img height="1" width="1" style="display:none"
               src="https://www.facebook.com/tr?id=604117387548801&ev=PageView&noscript=1"
/></noscript>
<!-- End Facebook Pixel Code -->
<style scoped lang="scss">
    @import "../../styles/type8";
    *{
        -moz-user-select:none;
        -webkit-user-select:none;
        user-select:none;
    }
    .page{
        display: inline-block;
        width: 100%;
        background: #fff;
        height: 100vh;
    }
    .page-content{
        max-width: 700px;
        margin:auto;
        padding: 20px;
        p{
            line-height: 1.6;
            margin-bottom: 20px;
            margin: 0 0 10px;
        }
    }
    .rand_pic{
        width: 100%;
    }
    .downloadCon{
        width: 100%;
        text-align: center;
        color: #1f80e3;
        font-size:1.25rem;
        font-weight: bold;
        margin-top: 30px;
        .name{
            color: #fe3f72;
            font-size: 1.7rem;
        }
        .num{
            color:  #e31f44;
            font-size: 1.65rem;
        }
    }
    .clickImage{
        margin-top: -10px;
        text-align: center;
        img{
            max-width: 100%;
        }
    }
    .center{
        display: inline-block;
        width: 100%;
        margin: auto;
        margin-bottom: 20px;
        .download-btn {
            display: block;
            width: 100%;
            text-align: center;
            img{
                width: 172px;
                height: 49px;
            }
        }
    }
</style>
